<template>
  <legend-map ref="legendMapRef" legend-code="new_pipe_network_legend"
    :forbidden-list="['物探点', '市政压力管线', '中压管线', '高压管线', '供水范围', '水厂范围', '管材管径']"
    :default-pitch-on="['管线', '供水范围', '水厂范围']" @layer-click="handleLayerClick"
    @selected-id-change="handleSelectedIdChange" @legend-toggle="handleLegendToggle"
    @scale-to-ratio="handleScaleToRatio" />
</template>
<script>
import LegendMap from '../mapModule/LegendMap.vue'

export default {
  name: 'LegengMap',
  components: {
    LegendMap
  },
  methods: {
    // 处理图层点击事件
    handleLayerClick (data) {
      this.$emit('layer-click', data)
    },
    // 处理选中ID变化事件
    handleSelectedIdChange (data) {
      this.$emit('selected-id-change', data)
    },
    // 处理图例切换事件
    handleLegendToggle (visible) {
      this.$emit('legend-toggle', visible)
    },
    // 处理缩放到指定比例事件
    handleScaleToRatio (data) {
      // this.$emit('scale-to-ratio', data)
    },
    // 暴露给父组件调用的方法
    handleShowLegend () {
      if (this.$refs.legendMapRef) {
        this.$refs.legendMapRef.handleShowLegend()
      }
    }
  }
}
</script>